import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

/**
 *Interceptor Angular que agrega el token de sesion valido actual a todas las
 *solicitudes http que no provengan del modulo de autenticacion
 * @export
 * @class SessionInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  constructor(private authSvc: AuthenticationService, private router: Router) {}

  /**
   * We check if the user is logged in, if not we redirect to the login page, if yes
   * we get the session token and add it to the request header
   * @param request - HttpRequest<unknown>
   * @param {HttpHandler} next - HttpHandler
   * @returns Observable<HttpEvent<unknown>>
   */
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return this.authSvc.isLogged().pipe(
      switchMap((isLogged) => {
        if (!request.url.includes('auth/') && !isLogged) {
          this.router.navigate(['/']);
        }
        return this.authSvc.getSession();
      }),
      switchMap((session) => {
        let req: HttpRequest<unknown>;

        if (
          (!request.url.includes('auth') &&
            !request.url.includes('assets') &&
            !request.url.includes('dismiss')) ||
          request.url.includes('authorizations')
        ) {
          req = request.clone({
            setHeaders: {
              [environment.authHeaderName]: 'Bearer ' + session.sessionToken,
            },
          });
        } else {
          req = request.clone();
        }

        return next.handle(req);
      })
    );
  }
}
